<template>
    <div>
        <rkm-area
            v-if="form && paciente.nome"
            title="Identificação"
            type="fieldset"
            no-margin-top
        >
            <rkm-row>
                <rkm-col class="flex-grow-1">
                    <rkm-row>
                        <rkm-col>
                            <h4>
                                {{ paciente.nome }}
                                <strong v-if="paciente.prefereNomeSocial">
                                    ({{ paciente.nomeSocial }})
                                </strong>
                            </h4>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="3">
                            <p>
                                <strong>Prontuário: </strong>
                                <template v-if="paciente.prontuario">
                                    {{ paciente.prontuario }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>
                            <p>
                                <strong>Data de nascimento: </strong>
                                <template v-if="paciente.dataNascimento">
                                    {{ paciente.dataNascimento }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>
                        </rkm-col>

                        <rkm-col cols="4">
                            <p>
                                <strong>CPF: </strong>
                                <template v-if="paciente.cpf">
                                    {{ paciente.cpf }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>
                            <p>
                                <strong>Idade:</strong>
                                <template>
                                    {{ paciente.idade }}
                                </template>
                            </p>
                        </rkm-col>

                        <rkm-col cols="3">
                            <p>
                                <strong>CNS: </strong>
                                <template v-if="paciente.cns">
                                    {{ paciente.cns }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>
                            <p>
                                <strong>Sexo:</strong>
                                <template>
                                    {{ paciente.sexo }}
                                </template>
                            </p>
                        </rkm-col>

                        <rkm-col>
                            <p>
                                <strong>RG: </strong>
                                <template v-if="paciente.rg">
                                    {{ paciente.rg }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>
                        </rkm-col>
                    </rkm-row>
                    <rkm-row>
                        <rkm-col>
                            <p>
                                <strong>Telefones: </strong>
                                <template v-if="paciente.telefones">
                                    {{ paciente.telefones }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>
                        </rkm-col>
                    </rkm-row>
                    <rkm-row>
                        <rkm-col>
                            <p>
                                <strong>Unidade: </strong>
                                <template v-if="paciente.unidadeReferencia">
                                    {{ paciente.unidadeReferencia }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>
                        </rkm-col>
                    </rkm-row>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            v-if="form && endereco.tipo"
            title="Endereço"
            type="fieldset"
            no-margin-top
        >
            <rkm-row>
                <rkm-col class="flex-grow-1">
                    <rkm-row>

                        <rkm-col cols="10">
                            <p>
                                <strong>Endereço: </strong>
                                <template v-if="endereco.logradouro">
                                    {{ endereco.logradouro.tipoNome }}, {{ endereco.numero }} {{ endereco.complemento }}
                                    - {{ endereco.bairro }}, {{ endereco.municipio }} - {{ endereco.uf }} - {{ endereco.cep }}
                                </template>
                            </p>
                        </rkm-col>

                        <rkm-col>
                            <p>
                                <strong>Código IBGE: </strong>
                                <template v-if="endereco.ibge">
                                    {{ endereco.ibge }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>
                        </rkm-col>
                    </rkm-row>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            title="Viagens agendadas"
        >

            <rkm-button
                v-if="items.length > 0"
                @click="selecionarTodos()"
                color="primary"
                slot="trailing"
            >
                <template v-if="handleDisable">
                    Selecionar todos
                </template>

                <template v-else>
                    Desmarcar selecionado(s)
                </template>
            </rkm-button>

            <rkm-button
                v-if="items.length > 0 && !handleDisable"
                @click="handleAlterarSelecionados()"
                color="primary"
                slot="trailing"
            >
                Alterar viagens selecionadas(s)
            </rkm-button>

            <rkm-button
                v-if="items.length > 0 && !handleDisable"
                @click="handleCancelSelecionados()"
                color="danger"
                slot="trailing"
            >
                Cancelar viagens selecionadas(s)
            </rkm-button>

            <rkm-table
                :items="items"
                :fields="fields"
                sort-by="dataSaida"
            >
                <template v-slot:cell(checkbox)="{ item }">
                    <rkm-form-checkbox
                        v-model="item.selecionado"
                        @change="handleBlur()"
                        :disabled="item.statusId !== enums.status.ABERTO && item.statusId !== enums.status.MODIFICADO && item.statusId !== enums.status.REAGENDADO"
                    />
                </template>

                <template v-slot:cell(dataSaida)="{ item }">
                    {{ getFormatedDate(item.dataSaida, "DD/MM/YYYY") }}
                </template>

                <template v-slot:cell(horarioSaida)="{ item }">
                    {{ item.horarioSaida ? item.horarioSaida : '-' }}
                </template>

                <template v-slot:cell(actions)="{ item }">
                    <rkm-button
                        color="primary"
                        title="Editar"
                        small
                        @click="handleAlter(item)"
                    >
                        <rkm-icon icon="pen" />
                    </rkm-button>

                    <rkm-button
                        color="danger"
                        title="Cancelar"
                        small
                        @click.stop="handleCancel(item)"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                    <rkm-button
                        color="info"
                        :title="`Agendamento: ${item.dataAgendamento} - ${ item.agendador } - ${ item.unidadeAgendadora }`"
                        small
                    >
                        <rkm-icon icon="info-circle" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>

        <Modal
            ref="Modal"
            :paciente="paciente"
            :items="items"
            :agendarTransporteJornada="form.agendarTransporteJornada"
            :pontos="form.pontos ? form.pontos : []"
            :municipios="form.municipiosDestinos ? form.municipiosDestinos : []"
            @close-modal="refreshParentModal"
        />
    </div>
</template>

<script>

// Moment.
import moment from 'moment'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { error, repository, object, data, stringCase, printTransportePacienteAgendar} from '@/mixins'

// Filters.
import format from '@/filters/formats'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'
import status from "@/enums/transporte-paciente/status"
import racaCor from "@/enums/cadastro/cidadao/racaCor"

// Utils
import validaCpf from '@/utils/validations/cpf'
import validaCns from '@/utils/validations/cns'

// Components.
import Modal from '@/components/transporte-paciente/gerenciamento/Modal'

export default {
    components: {
        Modal,
    },
    computed: {
        handleDisable() {

            const selecionados = this.items.filter(item => item.selecionado)

            return selecionados.length === 0 ? true : false
        },
        fields() {
            return [
                {
                    key: 'checkbox',
                    label: '#',
                    class: 'col-min text-center',
                },
                {
                    key: 'dataSaida',
                    label: 'Data saída',
                    class: 'col-min text-center',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'horarioSaida',
                    label: 'Horário saída',
                    class: 'col-min text-center',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'horario',
                    label: 'Horário consulta',
                    class: 'col-min text-center',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'municipio.nome',
                    label: 'Município',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'destino',
                    label: 'Destino',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'motivo.descricao',
                    label: 'Motivo',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'tipoPassageiro.descricao',
                    label: 'Tipo de Passageiro',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'veiculo.descricao',
                    label: 'Veículo',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'jornada.descricao',
                    label: 'Jornada',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'protocolo',
                    label: 'Protocolo'
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min text-center'
                },
            ];
        },
    },
    created() {

        this.repositories = {
            gerenciamento: this.getConectaSusRepository('transportePaciente.gerenciamento'),
        }

        this.load()
    },
    data: () => ({
        form: [],
        items: [],
        filterDefault: {},
        utils: {
            validaCpf,
            validaCns
        },
        paciente: {
            id: null,
            nome: null,
            preferenciaNomeId: null,
            nomeSocial: '',
            prontuario: null,
            cpf: null,
            cns: null,
            telefone: null,
            dataNascimento: null,
            classificacaoId: null,
            idade: null,
            anos: null,
            meses: null,
            dias: null,
            sexo: null,
            sexoId: null,
            sexoDescricao: '',
            nomeMae: '',
            convenioMedicoNome: '',
            classificacaoNome: '',
        },
        endereco: {
            tipo: null,
            logradouro: null,
            numero: null,
            complemento: null,
            bairro: null,
            cep: null,
            municipio: null,
            uf: null,
        },
        selecionados: false,
        enums: {
            preferenciaNome,
            status,
            racaCor
        },
        pontos: [],
        municipios: [],
        idsCancelado: [],
        idsAlterado: []
    }),
    filters: {
        ...format,
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.gerenciamento.show(this.id)
                .then(({ data }) => {

                    this.form = data.form
                    this.pontos = data.form.pontos
                    this.municipios = data.form.municipiosDestinos
                    this.model = data.model
                    this.items = data.model.agendamentos

                    this.atualiza = true

                    if(!this.items.length > 0){

                        this.atualiza = false
                    }

                    this.filterDefault = {
                        form: this.clone(this.form),
                        model: this.clone(this.model)
                    }

                    if (data.form.paciente) {
                        this.loadPaciente(data.form.paciente)
                    }
                    this.loadEndereco(data.form.endereco)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        refreshParentModal() {

            this.load()
        },
        save() {

            this.setLoading()

            this.repositories.gerenciamento.store(this.prepareData())
                .then(() => {this.showSaveNotification(), this.handlePrint()})
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareData() {

            const pacienteId = this.form.paciente.id
            const agendar = this.clone(this.items)

            agendar.forEach(agendamento => {

                agendamento.motivoId = agendamento.motivo.id
                agendamento.municipioId = agendamento.municipio.id

                delete(agendamento.motivo)
                delete(agendamento.municipio)
            })

            return this.camelObjectKeysToSnakeRecursive({agendar, pacienteId, idsCancelado:this.idsCancelado})
        },
        handlePrint() {

            let agendamento = []

            this.items.filter(item => item.alterado == true).map(item => {

                let acompanhante1Nome;
                let acompanhante2Nome;

                if(item.acompanhante1.nome && item.acompanhante1.nome.cidadao) {
                    acompanhante1Nome = item.acompanhante1.nome.cidadao.nome;
                } else {
                    acompanhante1Nome = item.acompanhante1.nome;
                }

                if(item.acompanhante2.nome && item.acompanhante2.nome.cidadao) {
                    acompanhante2Nome = item.acompanhante2.nome.cidadao.nome;
                } else {
                    acompanhante2Nome = item.acompanhante2.nome;
                }

                let viagem = {
                    pacienteNome: this.form.paciente.nome,
                    pacienteNomeSocial: this.form.paciente.nomeSocial,
                    dataNascimento: this.form.paciente.dataNascimento,
                    prontuario: this.form.paciente.prontuario,
                    logotipo: this.form.cliente.logotipo,
                    nomePrefeitura: this.form.cliente.nome,
                    ramoAtividade: this.form.cliente.sistema.ramoAtividade.nome,
                    mensagemProtocolo: this.form.mensagemProtocolo,
                    sistemaNome: this.form.cliente.sistema.nome,
                    sistemaVersao: this.form.cliente.sistema.versao,
                    usuario: this.form.usuario,
                    acompanhantes: item.acompanhante ? item.acompanhante : 'NÃO',
                    dataSaida: this.getFormatedDate(item.dataSaida, 'DD/MM/YYYY'),
                    horarioSaida: item.horarioSaida
                        ? moment(item.horarioSaida, 'HH:mm').format('HH:mm')
                        : 'NÃO INFORMADO',
                    motivo: item.motivo.descricao ? item.motivo.descricao : "NÃO INFORMADO",
                    ponto: item.ponto ? item.ponto : "NÃO INFORMADO",
                    destino: item.destino ? item.destino : "NÃO INFORMADO",
                    veiculo: item.veiculoId ? item.numeroPlaca + ' - ' + item.descricaoModelo : "NÃO INFORMADO",
                    comprovanteAcompanhante: this.form.comprovanteAcompanhante,
                    acompanhante1Nome,
                    acompanhante1Cns: item.acompanhante1.cns,
                    acompanhante1Telefone: item.acompanhante1.telefone,
                    acompanhante1Relacao: item.acompanhante1.relacaoId ? this.form.relacoes.find(relacao => relacao.id == item.acompanhante1.relacaoId).descricao : null,
                    acompanhante2Nome,
                    acompanhante2Cns: item.acompanhante2.cns,
                    acompanhante2Telefone: item.acompanhante2.telefone,
                    acompanhante2Relacao: item.acompanhante2.relacaoId ? this.form.relacoes.find(relacao => relacao.id == item.acompanhante2.relacaoId).descricao : null,
                }

                agendamento.push(viagem)
            })

            if (agendamento.length > 0) {
                this.print().agendamentos(agendamento)
            }
        },
        handlePhone(arr) {
            let telefones = '';

            arr.forEach(function(item, i) {
                if (i === 0) {
                    telefones = telefones.concat(item.numeroFormatado);
                } else {
                    telefones = telefones.concat(`, ${item.numeroFormatado}`);
                }
            });

            return telefones;
        },
        loadPaciente(paciente) {

            this.paciente.nome = paciente.nome
            this.paciente.prefereNomeSocial = paciente.prefereNomeSocial
            this.paciente.nomeSocial = paciente.nomeSocial
            this.paciente.telefones = this.handlePhone(paciente.telefones)
            this.paciente.dataNascimento = paciente.dataNascimento
            this.paciente.situacaoFamiliar = paciente.situacaoFamiliar
            this.paciente.rg = paciente.rg
            this.paciente.cpf = paciente.cpf
            this.paciente.classificacaoId = paciente.classificacaoId
            this.paciente.classificacaoNome = paciente.classificacaoNome
            this.paciente.convenioMedicoNome = paciente.convenioMedicoNome
            this.paciente.cns = paciente.cns
            this.paciente.prontuario = paciente.prontuario
            this.paciente.unidadeReferencia = paciente.unidade
            this.paciente.sexo = paciente.sexo.descricao
            this.paciente.idade = paciente.idade

            if (!paciente.cns || !this.utils.validaCns(paciente.cns) || !paciente.dataNascimento || !paciente.sexo.id
                || !paciente.nome || !paciente.nacionalidadeId || !paciente.domicilioId || !paciente.racaCorId
                || paciente.racaCorId == this.enums.racaCor.INDIGENA && !paciente.etniaIndigenaId
                || paciente.telefones.length === 0){

                    const confirm = async () => {
                        return true
                    }

                    const cancel = async () => {

                        this.$emit('handleExitPaciente')
                    }

                    const msg = `O cadastro do(a) paciente selecionado(a) está incompleto e a viagem não será faturada.
                        Deseja continuar?`

                        this.showConfirmation(msg, confirm, cancel)

                    return false
            }
        },
        loadEndereco(endereco) {

            this.endereco.tipo = endereco.logradouro.tipo
            this.endereco.logradouro = endereco.logradouro
            this.endereco.numero = endereco.numero
            this.endereco.complemento = endereco.complemento
            this.endereco.bairro = endereco.logradouro.bairro.nome
            this.endereco.cep = endereco.cep
            this.endereco.municipio = endereco.municipio.nome
            this.endereco.uf = endereco.municipio.estado.uf
            this.endereco.ibge = endereco.municipio.ibge
        },
        handleCancel(item) {

            if (item.statusId !== this.enums.status.ABERTO && item.statusId !== this.enums.status.MODIFICADO && item.statusId !== this.enums.status.REAGENDADO) {

                this.showAlert('Não é possível cancelar o agendamento, pois ele já foi finalizado.', 'Atenção')

            } else {

                const objIndex = this.items.findIndex((obj => obj.id == item.id));

                const destroy = async () => this.items.splice(objIndex, 1)

                this.idsCancelado.push(item.id)

                this.showDeleteConfirmation('Deseja realmente cancelar a viagem?', destroy)
            }
        },
        handleAlter(item) {

            if (item.statusId !== this.enums.status.ABERTO && item.statusId !== this.enums.status.MODIFICADO && item.statusId !== this.enums.status.REAGENDADO) {

                this.showAlert('Não é possível alterar o agendamento, pois ele já foi finalizado.', 'Atenção')

            } else {

                this.$refs.Modal.open(item)
            }
        },
        handleAlterarSelecionados() {

            const selecionados = this.items.filter(item =>
                item.selecionado &&
                (item.statusId === this.enums.status.ABERTO ||
                item.statusId === this.enums.status.MODIFICADO ||
                item.statusId === this.enums.status.REAGENDADO)
            )

            const mesmoMotivoId = selecionados.every(item => item.motivo.id === selecionados[0].motivo.id)
            const mesmoMunicipioId = selecionados.every(item => item.municipio.id === selecionados[0].municipio.id)
            const mesmoDestinoId = selecionados.every(item => item.destino.id === selecionados[0].destino.id)
            const mesmoHorario = selecionados.every(item => item.horario === selecionados[0].horario)
            const mesmoAcompanhante = selecionados.every(item => item.acompanhante === selecionados[0].acompanhante)
            const mesmoPontoId = selecionados.every(item => item.pontoId === selecionados[0].pontoId)
            const mesmoHorarioSaida = selecionados.every(item => item.horarioSaida === selecionados[0].horarioSaida)
            const mesmoTipoPassageiroId = selecionados.every(item => item.tipoPassageiroId === selecionados[0].tipoPassageiroId)
            const mesmoVeiculoId = selecionados.every(item => item.veiculoId === selecionados[0].veiculoId)

            if (!mesmoMotivoId || !mesmoMunicipioId || !mesmoDestinoId || !mesmoHorario || !mesmoAcompanhante || !mesmoPontoId || !mesmoHorarioSaida || !mesmoTipoPassageiroId || !mesmoVeiculoId) {

                this.showAlert('Para alterar vários agendamentos, é necessário que todos agendamentos tenham os mesmos dados. Somente as datas podem ser diferentes.', 'Atenção')
            } else {

                this.$refs.Modal.open(selecionados)
            }

        },
        handleCancelSelecionados() {

            const cancel = async () => this.items.filter(item => item.selecionado
                && (item.statusId === this.enums.status.ABERTO || item.statusId === this.enums.status.MODIFICADO || item.statusId === this.enums.status.REAGENDADO)).map((item) => {

                    const objIndex = this.items.findIndex((obj => obj.id == item.id))

                    this.idsCancelado.push(item.id)

                    this.items.splice(objIndex, 1)
            })

            this.showDeleteConfirmation(`Deseja realmente cancelar as viagens selecionadas?`, cancel)
        },
        handleBlur(){

            let selecionado = false

            this.items.map(item => {

                if (item.selecionado == true) {

                    selecionado = true
                }
            })

            if (selecionado) {

                this.selecionados = true
            } else {

                this.selecionados = false
            }
        },
        selecionarTodos(){

            if(this.selecionados == false){

                this.selecionados = true
                this.items.map(item => (item.selecionado = true && (item.statusId === this.enums.status.ABERTO || item.statusId === this.enums.status.MODIFICADO || item.statusId === this.enums.status.REAGENDADO)))
            } else {

                this.selecionados = false
                this.items.map(item => (item.selecionado = false && (item.statusId === this.enums.status.ABERTO || item.statusId === this.enums.status.MODIFICADO || item.statusId === this.enums.status.REAGENDADO)))
            }
        },
    },
    mixins: [ error, repository, object, data, stringCase, printTransportePacienteAgendar ],
    props: {
        id: { type: [Number], default: null }
    },
};

</script>

<style scoped>
.dataSaida { width:150px }
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    line-height: 35px;
    font-weight: 600;
}
p {
    margin: 0px;
}
</style>